import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { State } from 'redux/initialState';
import menuTypes from 'constants/menuTypes';
import { Draft, Society } from 'types';

import { getDrafts } from 'modules/drafts/redux/draftActions';
import { useGetActualSociety } from 'hooks/useGetActualSociety';
import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';

export const useDraftsList = () => {
  const dispatch = useDispatch();
  const { societyId } = useParams<{ societyId: string }>();

  const actualSociety = useSelector(
    (state: State) => state?.society?.actualSociety
  ) as Society | null;
  const actualSocietyDrafts = useSelector(
    (state: State) => state?.drafts
  ) as Draft[];

  const [isError, setIsError] = useState(false);

  useGetActualSociety(societyId);
  useGetMenu(menuTypes.EXTENDED);

  // Fetch drafts
  useEffect(() => {
    if (societyId) {
      const result = dispatch(getDrafts(societyId) as any);
      if (result && typeof result.then === 'function') {
        result.catch(() => {
          setIsError(true);
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [societyId]);

  const isLoading = !actualSociety;

  return {
    data: {
      actualSociety,
      drafts: actualSocietyDrafts || [],
    },
    isLoading,
    isError,
  };
};
